import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import { Mail, MailOpen } from 'lucide-react';
import { Card, CardContent } from '@/components/ui/card';
import { adminApi } from '@/lib/api';

export default function AdminMessagesPage() {
  const { t } = useTranslation();

  const { data: messages, isLoading } = useQuery({
    queryKey: ['admin-messages'],
    queryFn: () => adminApi.getMessages(),
  });

  if (isLoading) return <div className="p-8 text-center">Loading...</div>;

  return (
    <div>
      <h1 className="text-3xl font-bold mb-8">Contact Messages</h1>
      <div className="space-y-4">
        {messages && messages.length > 0 ? messages.map((msg: any) => (
          <Card key={msg.id} className={msg.isRead ? 'opacity-70' : ''}>
            <CardContent className="p-4">
              <div className="flex items-start gap-4">
                <div className={`h-10 w-10 rounded-full flex items-center justify-center ${msg.isRead ? 'bg-muted' : 'bg-primary'}`}>
                  {msg.isRead ? <MailOpen className="h-5 w-5 text-muted-foreground" /> : <Mail className="h-5 w-5 text-white" />}
                </div>
                <div className="flex-1">
                  <div className="flex justify-between items-start mb-2">
                    <div>
                      <h3 className="font-semibold">{msg.name}</h3>
                      <p className="text-sm text-muted-foreground">{msg.email}</p>
                    </div>
                    <span className="text-sm text-muted-foreground">{new Date(msg.createdAt).toLocaleDateString()}</span>
                  </div>
                  <p className="font-medium mb-1">{msg.subject}</p>
                  <p className="text-muted-foreground">{msg.message}</p>
                </div>
              </div>
            </CardContent>
          </Card>
        )) : (
          <Card>
            <CardContent className="p-8 text-center text-muted-foreground">
              No messages yet
            </CardContent>
          </Card>
        )}
      </div>
    </div>
  );
}
